export const OFFLINEFILES = "https://support.sheetgo.com/en/articles/8529755-sync-local-excel-files-from-desktop-to-onedrive"
export const SHEETGOSUPPORT = "https://support.sheetgo.com"
export const GETHELPSIGNUP = "https://support.sheetgo.com/en/articles/8529640-requirements-to-run-sheetgo-for-microsoft-365"
export const WHINEEDACCOUNT = "https://support.sheetgo.com/en/articles/8529640-requirements-to-run-sheetgo-for-microsoft-365"
